import { rankingItems } from '@/mocks/homeData';

export default function Ranking() {
  return (
    <section id="ranking" className="w-full bg-background-100 py-14 md:py-20">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">热播排行</h2>
            <p className="text-sm text-foreground-500">观众最爱的热门内容</p>
          </div>
          <a href="#index" className="text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap cursor-pointer">
            查看全部 <i className="ri-arrow-right-line ml-1"></i>
          </a>
        </div>

        <div className="bg-background-50 rounded-lg overflow-hidden">
          {rankingItems.map((item, idx) => (
            <a
              key={item.id}
              href="#ranking"
              className={`flex items-center gap-4 px-5 md:px-6 py-4 cursor-pointer transition-colors duration-200 hover:bg-background-100 ${
                idx < rankingItems.length - 1 ? 'border-b border-background-200/60' : ''
              }`}
            >
              <div className={`w-8 h-8 flex items-center justify-center rounded-md font-display text-sm flex-shrink-0 ${
                item.rank === 1 ? 'bg-accent-500 text-background-50' :
                item.rank === 2 ? 'bg-accent-400/80 text-background-50' :
                item.rank === 3 ? 'bg-accent-300/80 text-background-50' :
                'bg-background-200 text-foreground-500'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <div className="text-sm font-medium text-foreground-900">{item.title}</div>
                <div className="text-xs text-foreground-400">{item.category}</div>
              </div>
              <div className="flex items-center gap-2 flex-shrink-0">
                <span className="text-sm font-display text-primary-600">{item.heat}</span>
                {item.trend === 'up' && <i className="ri-arrow-up-line text-accent-500 text-sm"></i>}
                {item.trend === 'down' && <i className="ri-arrow-down-line text-foreground-400 text-sm"></i>}
                {item.trend === 'stable' && <i className="ri-subtract-line text-foreground-400 text-sm"></i>}
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}